interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 pt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        aria-label="上一页"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-9 min-w-9 whitespace-nowrap rounded-md px-3 text-sm font-medium transition-colors ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        aria-label="下一页"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}